module.exports = __webpack_public_path__ + "media/images/logo-cruze-site2-6d80d1c21d3c07e43087e071090ddaf3.png";